import client from 'services/client'

export const updateMyCaregiverInfos = async (body: any) => {
  const { data }: any = await client.patch('caregivers', body)
  return data
}
